var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"login-container"},[_c('img',{staticClass:"login-transition",attrs:{"src":require("@/assets/image/loading3.gif"),"alt":""}})])])
}]

export { render, staticRenderFns }